<script setup lang="ts">
import { inject, defineProps, ref } from 'vue'
import { PhCaretDown } from '@phosphor-icons/vue'

defineProps<{
  headline: string
  showLabel: string
  hideLabel: string
}>()

const isExpanded = inject('isExpanded', ref(false))
const toggleDropdown = inject('toggleDropdown', () => {})
</script>

<template>
  <button class="group flex justify-between items-center gap-3 w-full py-3 px-0.5
               border border-transparent focus-visible:outline-4 focus-visible:outline-secondary-500
               focus-visible:ring-0 focus-visible:ring-offset-0
               transition-shadow duration-200"
          :aria-expanded="isExpanded"
          :aria-label="isExpanded ? hideLabel : showLabel"
          role="button"
          tabindex="0"
          @keydown.enter.prevent="toggleDropdown"
          @keydown.space.prevent="toggleDropdown"
          @click="toggleDropdown">
    <div class="flex justify-between items-center w-full gap-2">
      <span class="text-foreground font-heading
                    group-hover:text-primary-350
                    group-focus-visible:text-primary-350
                    text-heading-xs md:text-heading-sm transition-colors duration-200">
        {{ headline }}
      </span>
      <div class="flex items-center gap-2">
        <span class="text-secondary-foreground font-ui
                    group-hover:text-foreground
                    group-focus-visible:text-foreground
                    text-ui-sm md:text-ui-lg transition-colors">
          {{ isExpanded ? hideLabel : showLabel }}
        </span>

        <PhCaretDown
          :class="[
            isExpanded ? 'rotate-180' : '',
            'text-secondary-foreground md:w-6 md:h-6 w-5 h-5',
            'group-hover:text-foreground group-focus-visible:text-foreground',
            'transition-transform transition duration-200'
          ]" />
      </div>
    </div>
  </button>
</template>
